export const messages = {
  labels: {
    comment: {
      id: 'treatmentSummary.Groups.SideEffectBundle.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
